// Reusable interactions helpers (hover/focus/child-hover)
// Usage: const detach = attachHoverFocus(el, { events, attrHover, attrHoverChild, ignoreInner });
// - events: { hoverStart, hoverEnd, focus, blur, hoverChildStart, hoverChildEnd }
// - attrHover/attrHoverChild: attribute names to toggle (defaults: data-hover, data-hover-child)
// - ignoreInner: selector to ignore as "child hover" (e.g., 'a,button')

import { emit } from './events.js';

export function attachHoverFocus(element, opts = {}) {
  if (!element || element.nodeType !== 1) return () => {};
  const events = opts.events || {};
  const attrHover = opts.attrHover || 'data-hover';
  const attrHoverChild = opts.attrHoverChild || 'data-hover-child';
  const ignoreInnerSel = opts.ignoreInner || 'a,button';

  const onEnter = () => { try { element.toggleAttribute(attrHover, true); if (events.hoverStart) emit(events.hoverStart, { element }, element); } catch (_) {} };
  const onLeave = () => { try { element.removeAttribute(attrHover); element.removeAttribute(attrHoverChild); if (events.hoverEnd) emit(events.hoverEnd, { element }, element); } catch (_) {} };
  const onFocus = () => { try { if (events.focus) emit(events.focus, { element }, element); } catch (_) {} };
  const onBlur = () => { try { if (events.blur) emit(events.blur, { element }, element); } catch (_) {} };
  const onOver = (ev) => {
    try {
      const t = ev && ev.target;
      if (!t || t === element) return;
      if (ignoreInnerSel) {
        const inner = t.closest && t.closest(ignoreInnerSel);
        if (inner && element.contains(inner)) return;
      }
      element.toggleAttribute(attrHoverChild, true);
      if (events.hoverChildStart) emit(events.hoverChildStart, { element, target: t }, element);
    } catch (_) {}
  };
  const onOut = (ev) => {
    try {
      const r = ev && (ev.relatedTarget || ev.toElement);
      if (r && element.contains && element.contains(r)) return;
      element.removeAttribute(attrHoverChild);
      if (events.hoverChildEnd) emit(events.hoverChildEnd, { element }, element);
    } catch (_) {}
  };

  try {
    element.addEventListener('mouseenter', onEnter, true);
    element.addEventListener('mouseleave', onLeave, true);
    element.addEventListener('focusin', onFocus, true);
    element.addEventListener('focusout', onBlur, true);
    element.addEventListener('mouseover', onOver, true);
    element.addEventListener('mouseout', onOut, true);
  } catch (_) {}

  return () => {
    try {
      element.removeEventListener('mouseenter', onEnter, true);
      element.removeEventListener('mouseleave', onLeave, true);
      element.removeEventListener('focusin', onFocus, true);
      element.removeEventListener('focusout', onBlur, true);
      element.removeEventListener('mouseover', onOver, true);
      element.removeEventListener('mouseout', onOut, true);
    } catch (_) {}
  };
}


